import { createAction, props } from '@ngrx/store';
import { MasterTemplateResponseData } from '@cpak/adp-cpak-bff-service-models';

export const updateNotSavedMasterTemplateChanges = createAction(
  'Master Template has not saved changes',
  props<{ templateId: string; templateData: Pick<MasterTemplateResponseData, 'categories'> }>()
);

export const removeNotSavedChangesForMasterTemplate = createAction(
  'Clear not saved changes for Master Template',
  props<{ templateId: string }>()
);

export const removeNotSavedChangesForAllTemplates = createAction('Clear not saved changes for all templates');
